import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs } from 'cerialize';
import { Itinerary } from './itinerary';

export class CreateRideSubscriptionRequest {
  @autoserializeAs(Itinerary)
  itinerary: Itinerary;

  @autoserializeAs(Date)
  startDate: Date;

  @autoserializeAs(Date)
  endDate: Date;

  @autoserialize
  days: string;

  static OnSerialized(instance: CreateRideSubscriptionRequest, json: any): void {
    if (!isNullOrUndefined(instance.startDate)) {
      json.startDate = DateUtil.serializeLocalDate(instance.startDate);
    }

    if (!isNullOrUndefined(instance.endDate)) {
      json.endDate = DateUtil.serializeLocalDate(instance.endDate);
    }
  }

  static OnDeserialized(instance: CreateRideSubscriptionRequest, json: any): void {
    if (!isNullOrUndefined(json['startDate'])) {
      instance.startDate = DateUtil.deserializeLocalDate(json['startDate']);
    }

    if (!isNullOrUndefined(json['endDate'])) {
      instance.endDate = DateUtil.deserializeLocalDate(json['endDate']);
    }
  }
}
